import { render, staticRenderFns } from "./MsisdnSummarySp.vue?vue&type=template&id=f696f172&"
import script from "./MsisdnSummarySp.vue?vue&type=script&lang=js&"
export * from "./MsisdnSummarySp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports